module.exports = __webpack_public_path__ + "img/logo-mappa-welcome.4285be65.png";